<template>
  <div class="pc-chatRoom">
    <div class="content">
      <!-- 首页问题展示 -->
      <div class="home_box" v-if="chatRecord.length<=0||!$store.state.token" >
        <select-model v-model="model"></select-model>
        <header>
          <div class="header_item">
            <i class="iconfont icon-taiyangtianqi" v-if="!/chatai.maibooxx.com/.test(location)"></i>
            <i class="iconfont icon-guangzhaoqiangdu" v-else></i>
            <span>提问实例</span>
          </div>
          <div class="header_item">
            <i class="iconfont icon-shandian" v-if="!/chatai.maibooxx.com/.test(location)"></i>
            <i class="iconfont icon-chaoqiangshengdian" v-else></i>
            <span>AI能力</span>
          </div>
          <div class="header_item">
            <i class="iconfont icon-weixian" v-if="!/chatai.maibooxx.com/.test(location)"></i>
            <i class="iconfont icon-about" v-else></i>
            <span>能力限制</span>
          </div>
        </header>
        <main>
          <ul>
            <li v-for="(item,index) in textList" :key="index" :class="{select:item.type==='click'}" @click="paddingContent(item)">
              <p>{{item.txt}}</p>
            </li>
          </ul>
        </main>
        <div><i class="iconfont icon-dengpao14hao"></i> 为了方便您以后能找到我们的网站，请按 <i>Ctrl+D</i> 收藏吧,或者下载<img src="../../assets/pc_img/chat_room_img/谷歌快捷方式.png" alt="快捷方式"><a href="https://chat-gpt-ai.cn/download/ChatAI_中文版.url">快捷方式文件</a>拖至桌面</div>
      </div>
      <!-- 问答聊天区 -->
      <div class="chat_area" v-else>
        <ul ref="imageDom">
          <template v-for="(item,index) in chatRecord">
            <li class="my_ask" :key="index" v-if="item.type==='Q'">
              <div class="chat_box">
                <p>{{item.message}}</p>
              </div>
              <!-- <i v-if="item.type==='A'&&index===chatRecord.length-1&&isChat"></i> -->
              <!-- <img :src="item.headImg" alt="head portrait"> -->
              <img :src="$store.state.userInfo.avatar" alt="" v-if="$store.state.userInfo.avatar">
              <img src="../../assets/pc_img/QA_chat_img/head portrait.png" alt="head portrait" v-else>
            </li>
            <li class="ai_answer" v-else-if="item.type==='A'" :key="index" @mousemove="touch=true;soundIdx=index" @mouseleave="touch=false">
              <img :src="item.headImg" alt="chatgpt icon">
              <div class="chat_box">
                <div v-for="(i,j) in item.message" :key="j" :class="{tail:index===chatRecord.length-1&&isChat&&j=== item.message.length-1}">
                  <mavon-editor
                  v-model="i.limitTxt"
                  v-if="i.limitTxt&&$store.state.userInfo.words_limit!==-1"
                  :subfield="false"
                  defaultOpen="preview"
                  :editable="false"
                  :toolbarsFlag="false"
                  previewBackground="#ececec"
                  :boxShadow="false"
                  ref="md"
                  codeStyle="monokai-sublime"
                  style="width: 45vw;border:0px;min-height:auto;min-width:auto;" />
                  <!-- ------ -->
                  <mavon-editor
                  v-model="i.txt"
                  v-else
                  :subfield="false"
                  defaultOpen="preview"
                  :editable="false"
                  :toolbarsFlag="false"
                  previewBackground="#ececec"
                  :boxShadow="false"
                  ref="md"
                  codeStyle="monokai-sublime"
                  style="width: 45vw;border:0px;min-height:auto;min-width:auto;" />
                </div>
                <span v-if="item.status==='limit'" class="limit" @click="$router.push('/upgrade_service')">(点击这里升级服务)</span>
                <span v-if="item.status==='limit'" class="limit" @click="$router.push('/user_center')">(点击这里邀请好友)</span>
                <span v-if="item.isLimit&&$store.state.userInfo.words_limit!==-1" class="success">(运营成本限制,回答字数受限,完整回答请点这里<i @click="$router.push('/upgrade_service')">升级服务</i>)</span>
              </div>
              <i class="iconfont icon-bofangyuyin" title="语音播放" @click="translationStart(item.message,index)" v-if="!sound&&touch&&index===soundIdx"></i>
              <i class="iconfont icon-zanting_huaban1" title="暂停播放" v-else-if="sound&&index===soundIdx&&touch" @click="translationEnd"></i>
              <em class="iconfont" :class="isCopy?'icon-duigoux':'icon-fuzhi'" v-if="touch" title="复制" @click="Copy(item.message[0].limitTxt?item.message[0].limitTxt:item.message[0].txt)"></em>
            </li>
          </template>
        </ul>
      </div>
      <!-- 选择语音播报 -->
      <div class="announcer">
        <span>语音:</span>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            {{announcer}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-microphone" command="x4_lingxiaowan_en">聆小琬(女声)</el-dropdown-item>
            <el-dropdown-item icon="el-icon-microphone" command="x4_lingxiaoyao_em">聆小瑶(女声)</el-dropdown-item>
            <el-dropdown-item icon="el-icon-microphone" command="x4_lingfeizhe_zl">聆飞哲(男声)</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="tool" v-if="this.chatRecord.length && $store.state.token">
        <div class="model">
          <span v-if="model=='4.0'">Model: GPT- 4</span>
          <span v-else>Model: Default(GPT-3.5)</span>
          <span v-if="model=='4.0'">今日可用机会: <i style="font-weight:bold">{{gpt4_count}}</i> 次</span>
        </div>
      </div>
    </div>
    <footer>
      <div class="center_box">
        <!-- 消息提示 -->
        <div class="pop-up_notification" v-if="isNot">
          <p>在这里输入您的问题 开始和AI对话</p>
        </div>
        <!-- 输入框 -->
        <div class="hl_input">
          <!-- <textarea type="text" placeholder="情感心理，文学写作，IT技术，健康百科..." v-model="input"  @keydown="handleKeydown" @focus="focus" :rows="rows>=5?5:rows" /> -->
          <el-input v-model="input" type="textarea" placeholder="情感心理，文学写作，IT技术，健康百科..." :rows="1" :autosize="{maxRows: 4}" @keydown.native="handleKeydown" @focus="focus"></el-input>
          <span class="el-icon-refresh" title="清空" @click="input =''"></span>
          <span class="iconfont icon-camera" title="截取聊天记录" v-if="!isCapture" @click="htmlToimg"></span>
          <round-loading v-else class="camera" type="banterLoader" title="等待截屏"/>
          <i class="iconfont icon-op_arrow" @click="InputChatContent" v-if="!isChat" title="发送"></i>
          <!-- <i class="iconfont icon-dengdai" v-else></i> -->
          <round-loading v-else class="loading" type="leapFrog"/>
          <i class="iconfont icon-zanting"  title="暂停" @click="ceaseChat" v-if="isChat"></i>
        </div>
        <!-- 语音聊天 -->
        <div class="voice_playback">
          <!-- 声音频段 -->
          <span class="start-taste-line" v-if="record">
            <hr class="hr hr1">
            <hr class="hr hr2">
            <hr class="hr hr3">
            <hr class="hr hr4">
            <hr class="hr hr5">
            <hr class="hr hr6">
            <hr class="hr hr7">
            <hr class="hr hr8">
            <hr class="hr hr9">
            <hr class="hr hr10">
          </span>
          <!-- 聊天 -->
          <i class="iconfont icon-zanting_huaban1" v-if="record" @click="soundRecordingEnd"></i>
          <i class="iconfont icon-yuyin" v-else @click="soundRecordingStart"></i>
        </div>
        <!-- 中止聊天 -->
        <!-- v-if="$store.state.cid!=='113'" -->
        <p >免责声明：本网站通过OpenAI API提供AI聊天服务，与OpenAI没有隶属关系 | <i @click="open('https://www.chat-gpt-ai.cn/terms-of-service.html')">服务协议</i></p>
        <p><span v-if="$store.state.version!==3">本网站由小桔计算机运营</span> | <i @click="open('https://beian.miit.gov.cn/#/')">{{$store.state.filings}}</i> | <i @click="open('https://www.chat-gpt-ai.cn/privacy.html')" v-if="$store.state.version!==3">隐私协议</i> </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GPT3Tokenizer from 'gpt3-tokenizer'
import { chatCompletion } from '@/api/ask_answer'
import TTSRecorder from '@/utils/TTSRecorder'
// 小语种-中文方言-appI
import IatRecorder from '@/utils/iatRecorder'
import html2canvas from 'html2canvas'
let ttsRecorder = new TTSRecorder()
const iatRecorder = new IatRecorder()
export default {
  name: 'PCChatRoom',
  props: {
    chatData: {
      tyoe: Array
    },
    RoomIdx: {
      type: Number
    },
    Prompt: {
      type: String
    },
    isNot: {
      type: Boolean
    },
    messageArr: {
      type: Array
    },
    textList: {
      type: Array
    },
    Rid: {
      type: String
    },
    serIp: {
      type: String
    },
    chatModel: {
      type: String
    }
  },
  components: {
    // codeBlock: () => import('@/components/code_block/code_block.vue'),
    roundLoading: () => import('@/components/loading/loading.vue'),
    selectModel: () => import('@/components/selectModel/selectModel.vue')
  },
  data () {
    return {
      // 用户输入内容
      input: '',
      // AI输出内容
      AIChat: '',
      // 聊天记录
      chatRecord: this.chatData,
      // 发送后台的聊天内容
      prompt: this.Prompt,
      // 发送到后台的聊天内容
      messageS: this.messageArr,
      // 是否是在聊天
      isChat: false,
      // 当前输入的 下标
      messageIdx: 0,
      // 标记是否开始输出代码
      AInum: 1,
      // 是否开始输出代码
      outputCode: false,
      // 中止聊天
      cease: false,
      // 是否结尾
      isEnding: false,
      // 检测连接超时
      time: null,
      // 当前的tokens
      tokenS: null,
      // 是否开始语音播放
      sound: false,
      soundIdx: null,
      // 移入显示播放
      touch: false,
      // 是否开始录音
      record: false,
      // 用户使用次数
      userNum: null,
      // 用户gpt-4次数
      gpt4_count: this.$store.state.userInfo.gpt4_count,
      // 语音
      speechSounds: localStorage.getItem('announcer') || 'x4_lingxiaowan_en',
      // 是否开始自动播放
      broadcast: false,
      // 是否截屏
      isCapture: false,
      // 是否复制
      isCopy: false,
      // 模型
      model: this.chatModel,
      // 域名
      location: ''
    }
  },
  created () {
    this.location = window.location.href
  },
  computed: {
    ...mapState(['roomId', 'userInfo', 'chatTimes', 'AllchatRecord']),
    rows () {
      return Number(Math.ceil((this.input && this.input.toString().length / 44) || 1))
    },
    announcer () {
      return this.speechSounds === 'x4_lingxiaowan_en' ? '聆小琬' : this.speechSounds === 'x4_lingxiaoyao_em' ? '聆小瑶' : this.speechSounds === 'x4_lingfeizhe_zl' ? '聆飞哲' : ''
    },
    // 区分3.5和4.0接口地址
    requestUrl () {
      return this.chatModel === '3.5' ? '/chat/chat-completion' : '/chat/chat-gpt4'
    },
    // 阈值
    threshold () {
      return this.chatModel === '3.5' ? 3000 : 5000
    }
  },
  methods: {
    // 发送问题
    async chatRoom () {
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${this.$store.state.token}`)
      myHeaders.append('Content-Type', 'application/json')
      const raw = { messages: this.messageS, token_len: this.tokenS }
      const controller = new AbortController()
      const signal = controller.signal
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(raw),
        redirect: 'follow',
        signal
      }
      // 当前会话索引
      const chatIdx = this.chatRecord.length - 1
      // 检测是否回复过慢
      this.time = setTimeout(() => {
        this.isChat = false
        this.messageIdx = 0
        this.AInum = 1
        // 中断请求
        controller.abort()
        this.chatRecord[chatIdx].message.push({ type: 'text', txt: `当前服务器正忙(${this.serIp})，请您重新发送您的问题` })
        this.chatRecord[chatIdx].status = 'error'
      }, 30000)
      fetch(process.env.VUE_APP_URL + this.requestUrl, requestOptions)
        .then(async response => {
          // console.log(response, 'response')
          clearInterval(this.time)
          if (response.status === 200) {
            // const reader = response.body.pipeThrough(new window.TextDecoderStream()).getReader()
            const reader = response.body.getReader()
            const decoder = new TextDecoder()
            // 减去一次使用次数
            if (this.model === '3.5') {
              if (this.userNum > 0) {
                this.userNum--
              }
            } else if (this.model === '4.0') {
              if (this.gpt4_count > 0) {
                this.gpt4_count--
              }
              const userinfo = this.userInfo
              userinfo.gpt4_count = this.gpt4_count
              this.$store.commit('setUserInfo', userinfo)
              localStorage.setItem('userInfo', JSON.stringify(userinfo))
            }
            while (true) {
              // value: 传输的字节 done 结束
              const { value, done } = await reader.read()
              if (done) {
                // AI停止聊天
                this.isChat = false
                this.messageIdx = 0
                this.AInum = 1
                // console.log(this.chatRecord, 'chatRecord')
                if (this.broadcast) {
                  // 语音自动播放
                  this.translationStart(this.chatRecord[chatIdx].message, chatIdx)
                  this.broadcast = false
                }
                // 存储本次聊天
                const AllRoom = this.$store.state.AllchatRecord
                AllRoom[this.RoomIdx].chatRecord = this.chatRecord
                AllRoom[this.RoomIdx].messageArr = this.messageS
                this.$store.commit('setAllchatRecord', AllRoom)
                localStorage.setItem('AllchatRecord', JSON.stringify(this.$store.state.AllchatRecord))
                break
              }
              // 聊天内容触底
              this.$nextTick(() => {
                const dom = this.$el.childNodes[0].childNodes[0]
                if (dom) {
                  dom.scrollTop = dom.scrollHeight
                }
              })
              // 将收到的二进制数据解码为字符串
              const str = decoder.decode(value)
              // 转换message 的数据类型
              // if (!this.chatRecord[this.chatRecord.length - 1].message[this.messageIdx]) {
              //   this.chatRecord[this.chatRecord.length - 1].message.push({
              //     type: '',
              //     txt: ''
              //   })
              // }
              // 字数限制
              if (this.messageS[this.messageS.length - 1].content.length < this.$store.state.userInfo.words_limit || this.userInfo.words_limit === -1) {
                // 未开启输出代码
                if (!this.outputCode) {
                  if (!this.chatRecord[chatIdx].message[this.messageIdx].type) {
                    this.chatRecord[chatIdx].message[this.messageIdx].type = 'text'
                  }
                  this.chatRecord[chatIdx].message[this.messageIdx].txt += str
                  // 开始输出代码
                } else if (this.outputCode) {
                  if (!this.chatRecord[chatIdx].message[this.messageIdx].type) {
                    this.chatRecord[chatIdx].message[this.messageIdx].type = 'code'
                  }
                  this.chatRecord[chatIdx].message[this.messageIdx].txt += str
                }
                this.messageS[this.messageS.length - 1].content += str
              } else {
                if (!this.chatRecord[chatIdx].message[this.messageIdx].limitTxt) {
                  this.chatRecord[chatIdx].message[this.messageIdx].limitTxt = this.chatRecord[chatIdx].message[this.messageIdx].txt + '********'
                }
                this.chatRecord[chatIdx].message[this.messageIdx].txt += str
                this.messageS[this.messageS.length - 1].content += str
                this.chatRecord[chatIdx].isLimit += true
                // AI停止聊天
                this.isChat = false
                this.messageIdx = 0
              }
              // 中止聊天
              if (this.cease) {
                // AI停止聊天
                this.isChat = false
                this.messageIdx = 0
                this.cease = false
                // console.log(this.chatRecord, 'chatRecord')
                // 存储本次聊天
                const AllRoom = this.$store.state.AllchatRecord
                AllRoom[this.RoomIdx].chatRecord = this.chatRecord
                AllRoom[this.RoomIdx].messageArr = this.messageS
                this.$store.commit('setAllchatRecord', AllRoom)
                localStorage.setItem('AllchatRecord', JSON.stringify(this.$store.state.AllchatRecord))
                break
              }
            }
          } else {
            return response.json()
          }
          // console.log(response, 'res')
        })
        .then((res) => {
          clearInterval(this.time)
          if (res) {
            if (res.code === 20006) {
              this.chatRecord[chatIdx].message.push({ type: 'text', txt: '用户次数已用尽，请升级当前的服务，我们会提供更优质的服务, 或者邀请好友，增加免费提问次数.' })
              this.chatRecord[chatIdx].status = 'limit'
            } else if (res.code === 10003) {
              this.chatRecord[chatIdx].message.push({ type: 'text', txt: '无法处理您的对话，可能是文字太长了，或者当前服务器正忙，建议减少提问字数或新建话题再试试.' })
              this.chatRecord[chatIdx].status = 'error'
            } else if (res.code === 10002) {
              this.chatRecord[chatIdx].message.push({ type: 'text', txt: '当前服务器正忙，请您重新发送您的问题.' })
              this.chatRecord[chatIdx].status = 'error'
            } else if (res.code === 1002) {
              this.chatRecord[chatIdx].message.push({ type: 'text', txt: '回答出现错误，请重新提问' })
              this.chatRecord[chatIdx].status = 'error'
              this.$message({
                message: '您的账号在其他设备登录，请重新登录.',
                type: 'warning'
              })
              this.$store.dispatch('signOut')
              this.$store.commit('login/setSign', 1)
              this.$store.commit('login/setIsShow', true)
            } else if (res.code === 20032) {
              this.chatRecord[chatIdx].message.push({ type: 'text', txt: res.msg })
              this.chatRecord[chatIdx].status = 'error'
            } else if (res.code === 10016) {
              this.chatRecord[chatIdx].message.push({ type: 'text', txt: '无法处理您的对话，建议减少提问字数重新提问.' })
              this.chatRecord[chatIdx].status = 'error'
            } else if (res.code === 20039) {
              this.chatRecord[chatIdx].message.push({ type: 'text', txt: '用户chat-4.0次数不足.' })
              this.chatRecord[chatIdx].status = 'error'
            } else if (res.code === 20001) {
              this.chatRecord[chatIdx].message.push({ type: 'text', txt: '对不起，当前聊天人数较多，请稍后重试' })
              this.chatRecord[chatIdx].status = 'error'
            }
            // 聊天内容触底
            this.$nextTick(() => {
              const dom = this.$el.childNodes[0].childNodes[0]
              if (dom) {
                dom.scrollTop = dom.scrollHeight
              }
            })
            // AI停止聊天
            this.isChat = false
            // AI聊天前缀回复默认
            this.AInum = 1
          }
          this.broadcast = false
        })
        .catch(error => {
          console.log(error, 'error')
          clearInterval(this.time)
          // 返回整个数据的接口
          this.jsonChatRoom()
        })
    },
    // 输入聊天内容
    InputChatContent () {
      if (!this.input.trim() || this.isChat || this.record) return
      if (this.model === '4.0' && this.userInfo.gpt4_count === 0) {
        this.$confirm('今日GPT4.0次数已用尽,是否新建一个聊天室?', {
          title: '提示',
          callback: (action) => {
            if (action === 'confirm') {
              const addRoom = document.querySelector('.add_room')
              addRoom.click()
            }
          }
        })
        return
      }
      if (!this.$store.state.token) {
        this.$store.commit('login/setIsShow', 1)
        return
      }
      // 检查弹出框是否 显示
      if (this.isNot) {
        this.$emit('setIsNot', {
          bol: false,
          index: this.RoomIdx
        })
      }
      // 如果是第一次发送信息,模型数据保存
      if (this.chatRecord.length === 0) {
        const AllRoom = this.AllchatRecord
        AllRoom[this.RoomIdx].chatModel = this.model
        this.$store.commit('setAllchatRecord', AllRoom)
        localStorage.setItem('AllchatRecord', JSON.stringify(this.$store.state.AllchatRecord))
      }
      // 发送消息成功
      this.chatRecord.push({
        headImg: this.userInfo.avatar ? this.userInfo.avatar : require('@/assets/pc_img/QA_chat_img/head portrait.png'),
        message: this.input,
        type: 'Q',
        status: 'success'
      })
      if (!this.messageS) {
        this.messageS = this.chatRecord.map((item) => {
          return {
            role: item.type === 'Q' ? 'user' : 'system',
            content: item.message
          }
        })
      }
      // 后台内容添加 (发送给后台MY)
      this.messageS.push({
        role: 'user',
        content: this.input
      })
      // 限制上下文联系最长为7个对话(包含回复)
      if (this.messageS.length > 7) {
        const index = this.messageS.length - 7
        this.messageS.splice(0, index)
      }
      // 判断是否有长文章
      this.messageS.forEach((item, index) => {
        if (item.role === 'system') {
          if (this.tokens(item.content) >= 1500) {
            // 调用回答缩减方法
            this.messageS[index].content = this.reduce(item.content)
          }
        }
      })
      // 判断是否超出 问答极限阈值(超出后删除)
      new Promise(this.monitorThreshold).then(() => {
        // this.prompt += 'Q:' + this.input + '/nA:'
        // 存储本次聊天
        const AllRoom = this.$store.state.AllchatRecord
        AllRoom[this.RoomIdx].chatRecord = this.chatRecord
        AllRoom[this.RoomIdx].messageArr = this.messageS
        AllRoom[this.RoomIdx].chatMessage = this.input
        AllRoom[this.RoomIdx].prompt = this.prompt
        this.$store.commit('setAllchatRecord', AllRoom)
        localStorage.setItem('AllchatRecord', JSON.stringify(this.$store.state.AllchatRecord))
        this.input = ''
        // console.log(this.$store.state.AllchatRecord, 'this.$store.state.AllchatRecord')
        // 添加AI聊天窗口
        this.chatRecord.push({
          headImg: require('@/assets/pc_img/QA_chat_img/chatgpt icon.png'),
          message: [{ type: 'text', txt: '' }],
          type: 'A',
          isLimit: false,
          status: 'success'
        })
        // 后台内容添加 (发送给后台AI)
        this.messageS.push({
          role: 'system',
          content: ''
        })
        // 聊天内容触底
        this.$nextTick(() => {
          const dom = this.$el.childNodes[0].childNodes[0]
          if (dom) {
            dom.scrollTop = dom.scrollHeight
          }
        })
        this.isChat = true
        // 发送聊天信息
        this.chatRoom()
      })
    },
    // 检查是否超出阈值
    monitorThreshold (resolve) {
      // 第一次提问不删除
      if (this.chatRecord.length === 1) {
        this.tokenS = this.tokens(JSON.stringify(this.messageS))
        resolve(true)
        return
      }
      // 最后一个提问是不删除的
      if (this.messageS.length === 1) {
        this.tokenS = this.tokens(JSON.stringify(this.messageS))
        resolve(true)
        return
      }
      // 删除超出tokens
      if (this.tokens(JSON.stringify(this.messageS)) >= this.threshold) {
        this.messageS.splice(0, 2)
        if (this.tokens(JSON.stringify(this.messageS)) >= this.threshold) {
          this.monitorThreshold(resolve)
        } else {
          this.tokenS = this.tokens(JSON.stringify(this.messageS))
          resolve(true)
        }
      } else {
        this.tokenS = this.tokens(JSON.stringify(this.messageS))
        resolve(true)
      }
    },
    // tokens 转换
    tokens (str) {
      const tokenizer = new GPT3Tokenizer({ type: 'gpt3' }) // or 'codex'
      let encoded = { bpe: [], text: [] }
      encoded = tokenizer.encode(str)
      // console.log(encoded, 'encoded')
      // console.log(encoded.text.length, 'tokens')
      return encoded.text.length
    },
    // 点击自动填充内容
    paddingContent ({ type, txt }) {
      if (type === 'click') {
        this.input = txt
      }
    },
    // 开启备案号网站
    open (url) {
      window.open(url)
    },
    // 聚焦 聊天触底
    focus () {
      // 聊天内容触底
      this.$nextTick(() => {
        const dom = this.$el.childNodes[0].childNodes[0]
        if (dom) {
          dom.scrollTop = dom.scrollHeight
        }
      })
    },
    // 发送问题 3.0版本
    sendQA () {
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${this.$store.state.token}`)
      myHeaders.append('Content-Type', 'application/json')
      const raw = { prompt: this.prompt }
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(raw),
        redirect: 'follow'
      }
      fetch(process.env.VUE_APP_URL + '/chat/completion', requestOptions)
        .then(async response => {
          // console.log(response, 'response')
          if (response.status === 200) {
            const reader = response.body.pipeThrough(new window.TextDecoderStream()).getReader()
            while (true) {
              // value: 传输的字节 done 结束
              const { value, done } = await reader.read()
              // console.log(value, 'value')
              if (done) {
                // AI停止聊天
                this.isChat = false
                this.prompt += this.AIChat + '/n'
                // AI聊天内容清空
                this.AIChat = ''
                // AI聊天前缀回复默认
                this.AInum = 1
                // 存储本次聊天
                const AllRoom = this.$store.state.AllchatRecord
                AllRoom[this.RoomIdx].chatRecord = this.chatRecord
                AllRoom[this.RoomIdx].prompt = this.prompt
                this.$store.commit('setAllchatRecord', AllRoom)
                localStorage.setItem('AllchatRecord', JSON.stringify(this.$store.state.AllchatRecord))
                break
              }
              // 聊天内容触底
              this.$nextTick(() => {
                const dom = this.$el.childNodes[0].childNodes[0]
                if (dom) {
                  dom.scrollTop = dom.scrollHeight
                }
              })
              // 字数限制
              if (this.chatRecord[this.chatRecord.length - 1].message.length < this.userInfo.words_limit || this.userInfo.words_limit === -1) {
                this.chatRecord[this.chatRecord.length - 1].message += value
                this.AIChat += value
              } else {
                this.chatRecord[this.chatRecord.length - 1].message += '********'
                this.chatRecord[this.chatRecord.length - 1].isLimit += true
                // AI停止聊天
                this.isChat = false
                this.prompt += this.AIChat + '/n'
                // 存储本次聊天
                const AllRoom = this.$store.state.AllchatRecord
                AllRoom[this.RoomIdx].chatRecord = this.chatRecord
                AllRoom[this.RoomIdx].prompt = this.prompt
                this.$store.commit('setAllchatRecord', AllRoom)
                localStorage.setItem('AllchatRecord', JSON.stringify(this.$store.state.AllchatRecord))
                return
              }
            }
          } else {
            return response.json()
          }
          // console.log(response, 'res')
        })
        .then((res) => {
          if (res) {
            if (res.code === 20006) {
              this.chatRecord[this.chatRecord.length - 1].message = '用户次数已用尽，请升级当前的服务，我们会提供更优质的服务, 或者邀请好友，增加免费提问次数.'
              this.chatRecord[this.chatRecord.length - 1].status = 'limit'
            } else if (res.code === 10003) {
              this.chatRecord[this.chatRecord.length - 1].message = '当前服务器正忙，请您重新发送您的问题.'
              this.chatRecord[this.chatRecord.length - 1].status = 'error'
            } else if (res.code === 10002) {
              this.chatRecord[this.chatRecord.length - 1].message = '当前服务器正忙，请您重新发送您的问题.'
              this.chatRecord[this.chatRecord.length - 1].status = 'error'
            } else if (res.code === 1002) {
              this.chatRecord[this.chatRecord.length - 1].message = '回答出现错误，请重新提问'
              this.chatRecord[this.chatRecord.length - 1].status = 'error'
              this.$message({
                message: '您的账号在其他设备登录，请重新登录.',
                type: 'warning'
              })
              this.$store.dispatch('signOut')
              this.$store.commit('login/setSign', 1)
              this.$store.commit('login/setIsShow', true)
            }
            // 聊天内容触底
            this.$nextTick(() => {
              const dom = this.$el.childNodes[0].childNodes[0]
              if (dom) {
                dom.scrollTop = dom.scrollHeight
              }
            })
            // AI停止聊天
            this.isChat = false
            // AI聊天前缀回复默认
            this.AInum = 1
          }
        })
        .catch(error => {
          console.log(error, 'error')
        })
    },
    // 停止聊天
    ceaseChat () {
      if (!this.isChat) return
      this.cease = true
    },
    // 回答缩减
    reduce (str) {
      let head = null
      let tail = null
      // 截取前第一句话
      for (let i = 0; i < str.length; i++) {
        if (str[i] === '。' || i >= str.length / 2) {
          // console.log(i, '下标')
          // console.log(str.slice(0, i), '第一句话')
          head = str.slice(0, i + 1)
          break
        }
      }
      // 获取最后一段话
      for (let i = str.length; i > 0; i--) {
        if ((str[i] === '。' && i !== str.length - 1) || i <= (str.length / 2)) {
          // console.log(i, '下标')
          // console.log(str.slice(i + 1), '最后一句话')
          tail = str.slice(i + 1)
          break
        }
      }
      return head + tail
    },
    // 发送聊天内容
    jsonChatRoom () {
      chatCompletion({ messages: this.messageS, token_len: this.tokenS }).then((res) => {
        // console.log(res, 'res')
        this.chatRecord[this.chatRecord.length - 1].message[this.messageIdx].type = 'text'
        this.chatRecord[this.chatRecord.length - 1].message[this.messageIdx].txt += res
        // AI停止聊天
        this.isChat = false
        this.messageIdx = 0
        this.AInum = 1
        // 存储本次聊天
        const AllRoom = this.$store.state.AllchatRecord
        AllRoom[this.RoomIdx].chatRecord = this.chatRecord
        AllRoom[this.RoomIdx].messageArr = this.messageS
        this.$store.commit('setAllchatRecord', AllRoom)
        localStorage.setItem('AllchatRecord', JSON.stringify(this.$store.state.AllchatRecord))
      }).catch(() => {
        // AI停止聊天
        this.isChat = false
        this.messageIdx = 0
        this.AInum = 1
        this.chatRecord[this.chatRecord.length - 1].message.push({ type: 'text', txt: `网络好像有点问题(${this.serIp}),请联系客服，或切换网络试试，例如关闭wifi，或连接别的wifi网络` })
        this.chatRecord[this.chatRecord.length - 1].status = 'error'
      })
    },
    // 开始语音转换
    translationStart (message, index) {
      if (this.sound || this.isChat) return
      this.soundIdx = index
      this.sound = true
      let text = ''
      message.forEach((item) => {
        if (item.type === 'code') {
          text += '代码展示'
        } else {
          text += item.txt
        }
      })
      ttsRecorder = new TTSRecorder({ defaultText: text, voiceName: this.speechSounds })
      ttsRecorder.start()
      ttsRecorder.wait().then(() => {
        this.sound = false
      })
    },
    // 结束语音转换
    translationEnd () {
      ttsRecorder.stop()
    },
    // 开始录音
    soundRecordingStart () {
      if (!this.$store.state.token) return
      if (this.model === '3.5') {
        if (this.userNum === 0) {
          this.$message({
            message: '用户次数不足，请升级服务.',
            type: 'error'
          })
          return
        }
      } else if (this.model === '4.0') {
        if (this.gpt4_count === 0) {
          this.$message({
            message: '用户gpt-4.0次数不足.',
            type: 'error'
          })
          return
        }
      }
      // 开启自动语音播放
      this.broadcast = true
      this.record = true
      iatRecorder.start()
      iatRecorder.onTextChange = (text) => {
        this.input = text
      }
      iatRecorder.wait().then(() => {
        this.record = false
      }).catch(() => {
        this.record = false
      })
    },
    // 结束录音
    soundRecordingEnd () {
      iatRecorder.stop()
    },
    // 选择播音人
    handleCommand (val) {
      this.speechSounds = val
      localStorage.setItem('announcer', val)
    },
    htmlToimg () {
      if (this.isCapture) return
      this.isCapture = true
      const dom = this.$refs.imageDom
      if (!dom) {
        this.isCapture = false
        this.$message({
          message: '截取聊天记录失败'
        })
        return
      }
      const scale = window.devicePixelRatio
      html2canvas(dom, {
        useCORS: true,
        allowTaint: false,
        height: dom.offsetHeight, // 画布高度
        width: dom.offsetWidth, // 画布宽度
        scrollX: 0,
        scrollY: 0,
        dpi: window.devicePixelRatio,
        scale: scale
      }).then((canvas) => {
        canvas.toBlob((blob) => {
          this.imgUrl = canvas.toDataURL('image/png', 1) // 获取生成的图片的url
          const eleLink = document.createElement('a')
          eleLink.href = this.imgUrl // 转换后的图片地址
          eleLink.download = '聊天记录'
          // 触发点击
          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
          this.isCapture = false
        })
      }).catch(() => {
        this.isCapture = false
      })
    },
    // 复制
    Copy (txt) {
      this.isCopy = true
      setTimeout(() => {
        this.isCopy = false
      }, 1500)
      // 创建input标签
      const input = document.createElement('textarea')
      // 将input的值设置为需要复制的内容
      input.value = txt
      // 添加input标签
      document.body.appendChild(input)
      // 选中input标签
      input.select()
      // 执行复制
      document.execCommand('copy')
      // 移除input标签
      document.body.removeChild(input)
    },
    // 键盘操作
    handleKeydown () {
      // 判断是否按下组合键和回车键
      if (event.ctrlKey && event.keyCode === 13) {
        // 按下组合键+回车，触发换行
        this.input += '\n'
      } else if (event.keyCode === 13) {
        event.preventDefault()
        // 按下回车，触发发送
        this.InputChatContent()
      }
    }
  },
  watch: {
    chatData: {
      handler (val) {
        this.chatRecord = val
      },
      deep: true
    },
    messageArr: {
      handler (val) {
        this.messageS = val
      },
      deep: true
    },
    Prompt (val) {
      this.prompt = val
    },
    '$store.state.userInfo.remain_count': {
      handler (val) {
        this.userNum = val
      }
    },
    '$store.state.userInfo.gpt4_count': {
      handler (val) {
        this.gpt4_count = val
      }
    },
    roomId (val) {
      // 不处于当前聊天室的关闭当前语音
      if (val !== this.Rid) {
        this.translationEnd()
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import url('./chatRoom.less');
</style>
